import { Consts } from '@/consts';
import { GraphApiResult } from '@/models/graphApiResult';
import { ApiResult } from '@/enums';
import { Channels, IChannels } from '@/models/channels';
import { StringUtils } from './stringUtils';
import { IGraphApiRootError, GraphApiRootError } from '@/models/graphApiRootError';
import { IChannel, Channel } from '@/models/channel';

export class ChannelUtils {
	public static async GetChannels(accessToken: string, groupId: string): Promise<GraphApiResult<Channels>> {
		const result = new GraphApiResult<Channels>();
		try {
			if (StringUtils.IsEmptyOrUndefined(accessToken) || StringUtils.IsEmptyOrUndefined(groupId)) {
				result.result = ApiResult.ParameterError;
				return result;
			}

			const headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options = {
				method: 'GET',
				headers
			};

			try {
				const url: string = `${Consts.GRAPH_API_BASE_URL}teams/${groupId}/channels/`;
				const response: Response = await fetch(url, options);
				if (!response.ok) {
					result.result = ApiResult.GraphApiError;
					const responseData: IGraphApiRootError = await response.json() as IGraphApiRootError;
					result.error = GraphApiRootError.parse(responseData);
					return result;
				}
				const ichannels: IChannels = await response.json() as IChannels;
				const channels = Channels.parse(ichannels);
				channels.ignore(Consts.CHANNEL_NAME_GENERAL);
				result.result = ApiResult.Success;
				result.value = channels;
				return result;
			} catch (error) {
				result.result = ApiResult.ResponseError;
				return result;
			}
		} catch (error) {
			console.error(error.message);
			result.result = ApiResult.UnknownError;
			return result;
		}
	}

	public static async GetChannel(
		accessToken: string,
		groupId: string,
		channelId: string): Promise<GraphApiResult<Channel>> {
		const result = new GraphApiResult<Channel>();
		try {
			if (StringUtils.IsEmptyOrUndefined(accessToken) ||
				StringUtils.IsEmptyOrUndefined(groupId) ||
				StringUtils.IsEmptyOrUndefined(channelId)) {
				result.result = ApiResult.ParameterError;
				return result;
			}

			const headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options = {
				method: 'GET',
				headers
			};

			try {
				const url: string = `${Consts.GRAPH_API_BASE_URL}teams/${groupId}/channels/${channelId}`;
				const response: Response = await fetch(url, options);
				const ichannel: IChannel = await response.json() as IChannel;
				const channel = Channel.parse(ichannel);
				result.result = ApiResult.Success;
				result.value = channel;
				return result;
			} catch (error) {
				result.result = ApiResult.ResponseError;
				return result;
			}
		} catch (error) {
			console.error(error.message);
			result.result = ApiResult.UnknownError;
			return result;
		}
	}

	public static async PostChannel(
		accessToken: string,
		groupId: string,
		channelName: string): Promise<GraphApiResult<Channel>> {
		const result = new GraphApiResult<Channel>();
		try {
			if (StringUtils.IsEmptyOrUndefined(accessToken) ||
				StringUtils.IsEmptyOrUndefined(groupId) ||
				StringUtils.IsEmptyOrUndefined(groupId)) {
				result.result = ApiResult.ParameterError;
				return result;
			}

			const headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			headers.append('Content-Type', 'application/json');

			const jsonStrings: string = JSON.stringify({
				'displayName': channelName
			});
			const options = {
				method: 'POST',
				body: jsonStrings,
				headers
			};

			try {
				const url: string = `${Consts.GRAPH_API_BASE_URL}teams/${groupId}/channels`;
				const response: Response = await fetch(url, options);
				const ichannel: IChannel = await response.json() as IChannel;
				const channel = Channel.parse(ichannel);
				result.result = ApiResult.Success;
				result.value = channel;
				return result;
			} catch (error) {
				result.result = ApiResult.ResponseError;
				return result;
			}
		} catch (error) {
			console.error(error.message);
			result.result = ApiResult.UnknownError;
			return result;
		}
	}
}
